export default __webpack_public_path__ + "static/media/alert-circle.db403a8b.svg";